<template>
    <div>
        <div class="filter-container">
            <div class="left-content">
                <div class="filter-block">
                    <b-form-group>
                        <multiselect
                            v-model="currentYear"
                            :options="yearsArr"
                            placeholder="Год"
                            :allow-empty="false"
                            :show-labels="false"
                        ></multiselect>
                    </b-form-group>
                </div>
                <div style="padding-left: 7px"></div>
                <div class="filter-block">
                    <b-form-group>
                        <multiselect
                            v-model="regionVal"
                            :options="regions"
                            :multiple="true"
                            :close-on-select="false"
                            :clear-on-select="false"
                            :preserve-search="true"
                            placeholder="Выбрать Регион"
                            label="nameRu"
                            track-by="id"
                            :preselect-first="true"
                            @select="handleFilterClick"
                            @remove="handleFilterClick"
                        >
                            <template
                                slot="selection"
                                slot-scope="{ values, search, isOpen }"
                                ><span
                                    class="multiselect__single"
                                    v-if="values.length &amp;&amp; !isOpen"
                                    >{{
                                        values.filter(
                                            (item) => item.nameRu !== "Все"
                                        ).length
                                    }}
                                    выбранные варианты</span
                                ></template
                            >
                        </multiselect>

                        <!-- <multiselect
                            v-model="formVal"
                            :options="reportTypes"
                            :multiple="true"
                            :close-on-select="false"
                            :clear-on-select="false"
                            :preserve-search="true"
                            placeholder="Выбрать формы"
                            label="name"
                            track-by="id"
                            :preselect-first="true">
                            <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} выбранные варианты</span></template>
                        </multiselect> -->
                    </b-form-group>
                </div>
                <div style="padding-left: 7px"></div>
                <div class="filter-block selected-list" v-if="regionVal">
                    {{
                        regionVal
                            .filter((item) => item.nameRu !== "Все")
                            .map((item) => item.nameRu)
                            .join(", ")
                    }}
                </div>
                <!-- <div class="filter-block">
                    <b-btn variant="primary" @click="loadZipFile">Применить</b-btn>
                </div> -->
            </div>
        </div>
        <!---------Начало грид таблицы-------------->
        <b-progress
            variant="success"
            v-show="bar < 100"
            height="10px"
            :value="bar"
            striped
            animated
        ></b-progress>
        <div class="table-container">
            <div class="b-table-sticky-header table-responsive-true">
                <table
                    class="table b-table table-bordered b-table-no-border-collapse"
                >
                    <thead>
                        <tr>
                            <td style="width: 40px"></td>
                            <td>Показатель</td>
                            <td style="width: 40px"></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td></td>
                            <td>
                                <a
                                    class="table-btn-link"
                                    style="font-size: 1rem"
                                    @click="loadVillagePassport"
                                >
                                    Паспорт села
                                </a>
                            </td>
                            <td>
                                <img
                                    :src="
                                        require('./icons/3-vertical-dots.svg')
                                    "
                                    height="17px"
                                    alt=""
                                />
                            </td>
                        </tr>
                        <tr :key="'itemIndx'">
                            <td></td>
                            <td>
                                <a
                                    variant="link"
                                    class="table-btn-link"
                                    @click="loadFormFile(0, 'СВОД')"
                                    >СВОД</a
                                >
                            </td>
                            <td>
                                <img
                                    :src="
                                        require('./icons/3-vertical-dots.svg')
                                    "
                                    height="17px"
                                    alt=""
                                />
                            </td>
                        </tr>
                        <template>
                            <template>
                                <template
                                    v-for="(item, index) of this.reportTypes"
                                >
                                    <tr :key="'itemIndx' + index">
                                        <td></td>
                                        <td>
                                            <a
                                                variant="link"
                                                class="table-btn-link"
                                                @click="
                                                    loadFormFile(
                                                        item.formCode,
                                                        item.name
                                                    )
                                                "
                                                >{{ item.name }}</a
                                            >
                                        </td>
                                        <td>
                                            <img
                                                :src="
                                                    require('./icons/3-vertical-dots.svg')
                                                "
                                                height="17px"
                                                alt=""
                                            />
                                        </td>
                                    </tr>
                                </template>
                            </template>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import { Ax } from "@/utils";
import { MonitoringSnpApi } from "@/modules/monitoring-snp/api/MonitoringSnpApi";

export default {
    name: "monitoring-form",
    props: ["reportTypes", "regions"],
    data() {
        return {
            bar: 0,
            tableFields: [
                {
                    key: "action",
                    label: "",
                },
                {
                    key: "name",
                    label: "Показатель",
                },
            ],
            globalArr: [],
            yearsArr: [],
            regionVal: null,
            currentYear: null,
            formVal: null,
            lastClickedOption: null,
            hostName: "",
        };
    },
    mounted() {
        const currentYear = new Date().getFullYear();
        this.listOfYears(currentYear);
        this.hostName = location.hostname.split(".")[0];
    },
    methods: {
        sendCurrentYear() {
            return this.currentYear;
        },
        listOfYears() {
            MonitoringSnpApi.get("/snp/api/v1/admin/years")
                .then(
                    (res) =>
                        (this.yearsArr = res?.data?.length
                            ? res.data.sort()
                            : [new Date().getFullYear()])
                )
                .catch(() => (this.yearsArr = []));
        },
        rowClass(item, type) {
            if (!item || type !== "row") {
                return;
            }
            if (!item.visible) {
                return "is-hidden";
            }
        },
        loadZipFile() {
            let url = "/snp/api/v1/report/file/multiform?";
            this.formVal.forEach((form) => {
                url += `forms=${form.id}&`;
            });
            url += `year=${this.currentYear}`;
            Ax(
                {
                    url,
                    method: "GET",
                    data: null,
                    responseType: "blob",
                    headers: {
                        Authorization: `Bearer ${this.$store.getters.token}`,
                    },
                },
                (data) => {
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", `forms.zip`);
                    document.body.appendChild(link);
                    link.click();
                },
                (error) => {
                    console.log("err", error);
                }
            );
        },
        filterIsValid() {
            const { currentYear, regionVal } = this;
            if (currentYear === null || currentYear === undefined) {
                alert("Вы не выбрали год");
                return false;
            }
            if (!regionVal || (regionVal && regionVal.length === 0)) {
                alert("Вы не выбрали регион");
                return false;
            }

            return true;
        },
        loadVillagePassport() {
            if (!this.filterIsValid()) return;

            let params = `?year=${this.currentYear}&zip=true`;
            let hasValidCodes = false;

            if (this.regionVal.map((item) => item.nameRu).includes("Все")) {
                const allRegion =
                    this.regionVal.find((item) => item.nameRu === "Все") ||
                    this.regions.find((item) => item.nameRu === "Все");
                if (allRegion && allRegion.code) {
                    params += `&cato_code=${allRegion.code}`;
                    hasValidCodes = true;
                } else {
                    const firstRegionWithCode = this.regionVal.find(
                        (item) => item.code
                    );
                    if (firstRegionWithCode && firstRegionWithCode.code) {
                        const fallbackCode =
                            firstRegionWithCode.code.toString().substr(0, 2) +
                            "0000000";
                        params += `&cato_code=${fallbackCode}`;
                        hasValidCodes = true;
                    }
                }
            } else {
                const codes = this.regionVal
                    .filter((item) => item.code)
                    .map((item) => `&cato_code=${item.code}`)
                    .join("");

                if (codes) {
                    params += codes;
                    hasValidCodes = true;
                }
            }

            if (!hasValidCodes) {
                alert("Коды регионов не определены");
                return;
            }

            // MonitoringSnpApi.downloadFile(
            //     `/snp/api/v2/report/export/doc${params}`,
            //     {}
            // );
            Ax(
                {
                    url: `/snp/api/v2/report/export/doc${params}`,
                    method: "GET",
                    data: null,
                    responseType: "blob",
                    headers: {
                        Authorization: `Bearer ${this.$store.getters.token}`,
                    },
                },
                (data) => {
                    const blobUrl = window.URL.createObjectURL(
                        new Blob([data])
                    );
                    const link = document.createElement("a");
                    link.href = blobUrl;
                    const now = new Date();
                    const pad = (n) => String(n).padStart(2, "0");
                    const dateTime =
                        `${now.getFullYear()}-` +
                        `${pad(now.getMonth() + 1)}-` +
                        `${pad(now.getDate())}_` +
                        `${pad(now.getHours())}-` +
                        `${pad(now.getMinutes())}`;
                    const regionName =
                        this.regionVal.length > 1
                            ? this.hostName
                            : this.regionVal[0].nameRu;
                    link.setAttribute(
                        "download",
                        `${this.currentYear}_${regionName}_ПаспортСела_${dateTime}.zip`
                    );
                    document.body.appendChild(link);
                    link.click();
                },
                (error) => {
                    console.log("Ошибка при загрузке файла:", error);
                }
            );
        },

        loadFormFile(formCode, fileName) {
            if (this.filterIsValid()) {
                this.loadFormWithRegion(formCode, fileName);
            }
        },
        loadFormWithRegion(formCode, fileName) {
            let url = "/snp/api/v2/report/export/xls?";
            let codesQuery = "";

            if (
                this.regionVal &&
                this.regionVal.map((item) => item.nameRu).includes("Все")
            ) {
                const allRegion =
                    this.regionVal.find((item) => item.nameRu === "Все") ||
                    this.regions.find((item) => item.nameRu === "Все");
                if (allRegion && allRegion.code) {
                    codesQuery += `cato_code=${allRegion.code}`;
                } else {
                    const firstRegionWithCode = this.regionVal.find(
                        (item) => item.code
                    ).code;
                    const allRegionCode =
                        firstRegionWithCode.toString().substr(0, 2) + "0000000";
                    codesQuery += `cato_code=${allRegionCode}`;
                }
            } else {
                this.regionVal.forEach((form) => {
                    if (form.code) {
                        codesQuery += `cato_code=${form.code}&`;
                    }
                });

                if (!codesQuery || codesQuery.trim() === "cato_code=") {
                    alert("Коды регионов не определены");
                    return;
                }
            }

            formCode !== 0
                ? (url += `${codesQuery}&form_code=${formCode}&year=${this.currentYear}`)
                : (url += `${codesQuery}&year=${this.currentYear}`);

            Ax(
                {
                    url: url,
                    method: "GET",
                    data: null,
                    responseType: "blob",
                    headers: {
                        Authorization: `Bearer ${this.$store.getters.token}`,
                    },
                },
                (data) => {
                    const blobUrl = window.URL.createObjectURL(
                        new Blob([data])
                    );
                    const link = document.createElement("a");
                    link.href = blobUrl;
                    const now = new Date();
                    const pad = (n) => String(n).padStart(2, "0");
                    const dateTime =
                        `${now.getFullYear()}-` +
                        `${pad(now.getMonth() + 1)}-` +
                        `${pad(now.getDate())}_` +
                        `${pad(now.getHours())}-` +
                        `${pad(now.getMinutes())}`;
                    const regionName =
                        this.regionVal.length > 1
                            ? this.hostName
                            : this.regionVal[0].nameRu;
                    link.setAttribute(
                        "download",
                        `${this.currentYear}_${regionName}_${fileName}_${dateTime}.xlsx`
                    );
                    document.body.appendChild(link);
                    link.click();
                },
                (error) => {
                    console.log("Ошибка при загрузке файла:", error);
                }
            );
        },

        handleFilterClick(option) {
            this.lastClickedOption = option.nameRu;
        },
    },
    watch: {
        regionVal(newArr, oldArr) {
            const newIncludesAll = newArr
                ?.map((item) => item.nameRu)
                .includes("Все");
            const oldIncludesAll = oldArr
                ?.map((item) => item.nameRu)
                .includes("Все");

            if (this.lastClickedOption === "Все") {
                if (newIncludesAll) {
                    this.regionVal = this.regions;
                } else if (oldIncludesAll) {
                    this.regionVal = [];
                }
            } else if (
                newArr?.length !== this.regions.length &&
                newIncludesAll
            ) {
                this.regionVal = this.regionVal.filter(
                    (item) => item.nameRu !== "Все"
                );
            } else if (
                newArr?.length === this.regions.length - 1 &&
                !newIncludesAll
            ) {
                this.regionVal = this.regions;
            }
        },
    },
};
</script>
<style lang="scss">
.table-container .table-btn-link {
    font-weight: bold;
    -webkit-box-shadow: none;
    box-shadow: none;
    text-transform: none;
    cursor: pointer;
}

.left-content {
    display: flex;
    gap: 8px;
}

.selected-list {
    color: #1c2a3e;
    font-weight: 700;
    font-size: 14px;
    max-width: 68%;
}
</style>
